/**
 * Owner: Masa Bayu
 * File: tokens.ts
 * Date:Time: 2026-10-15 08:20
 * Description: F1 tokens · LINE-02 join · wordStarts cardinality.
 */

import type { LinePaintSegment } from './types.js';

/**
 * Tokens that L2 word-span paint will draw (whitespace-split · non-space).
 * Extract/validator must use the same rule (R11.7e F1).
 */
export function paintTokens(text: string): readonly string[] {
  return text.split(/(\s+)/).filter((part) => part.length > 0 && !/^\s+$/.test(part));
}

/**
 * wordStarts absent → ok (plain / Q4 path).
 * Present → length must equal paintTokens(text).length.
 */
export function isWordStartsCardinalityOk(
  text: string,
  wordStarts: readonly number[] | undefined,
): boolean {
  if (wordStarts === undefined) return true;
  return wordStarts.length === paintTokens(text).length;
}

/** R11-LINE-02 · segments.map(s => s.text).join('') === line text. */
export function isSegmentsJoinOk(
  text: string,
  segments: readonly LinePaintSegment[] | undefined,
): boolean {
  if (segments === undefined || segments.length === 0) return false;
  return segments.map((s) => s.text).join('') === text;
}

export type CardinalityFailLog = {
  readonly lineId?: string;
  readonly reason: 'WORD_STARTS_NE_TOKEN_COUNT' | 'SEGMENTS_JOIN_NE_TEXT';
  readonly wordStartsLen?: number;
  readonly tokenCount?: number;
  readonly segmentsN?: number;
};

/** Best-effort console account · no tip mutation. */
export function logLinePaintCardinalityFail(entry: CardinalityFailLog): void {
  try {
    console.warn('[qx-line-paint] CARDINALITY_FAIL', entry);
  } catch {
    /* ignore */
  }
}
